// const backendDomain = "http://192.168.1.239/oakya_student_report"
// const backendDomain = "http://192.168.1.254/oakya_dev/sguaccounts/api"
const backendDomain = "https://sgustudentenquiry.oakyaitservices.in/api"           

const SummaryApi = {
    createStudent : {
        url : `${backendDomain}/student/student_create.php`,
        method : "POST"
    },
    getAllStudents : {    
        url : `${backendDomain}/student/student_retrieve.php`,
        method : "GET"
    },                                     
}     
                                                                                         
export default SummaryApi;     

     








